module.exports = __webpack_public_path__ + "static/media/Flotation.fce261af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/Flotation.jpg
// module id = 396
// module chunks = 0